import React, { memo, useContext } from 'react';
import PropTypes from 'prop-types';
import { AppContext } from '@prisjakt/ui-app-context';
import Dropdown from '@prisjakt/ui-dropdown';

import styled from 'styled-components';
import { Checkbox } from '@prisjakt/ui-inputs';

const StyledCheckbox = styled(Checkbox)`
  label {
    padding: 5px 0;
  }
`;

const GraphSelector = ({ options, onAdd, onRemove }) => {
  const { t } = useContext(AppContext);
  return (
    <Dropdown
      title={t('product', 'price-history.select-curves')}
      type="custom-content-type"
    >
      <div>
        {options.map(({ name, value, active, disabled }) => (
          <StyledCheckbox
            key={value}
            name={value}
            checked={active && !disabled}
            disabled={disabled}
            label={name}
            onChange={() => {
              if (active) {
                onRemove(value);
              } else {
                onAdd(value);
              }
            }}
          />
        ))}
      </div>
    </Dropdown>
  );
};

GraphSelector.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      value: PropTypes.string,
      active: PropTypes.bool,
      disabled: PropTypes.bool,
    })
  ).isRequired,
  onAdd: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
};

export default memo(GraphSelector);
